import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'upp-numpad',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './upp-numpad.html',
    styleUrls: ['./upp-numpad.scss'],
})
export class UppNumpadComponent {
    /** When true, the accept key is non-interactive and does not emit `accept`. */
    @Input() disabled = false;

    @Output() keyPress = new EventEmitter<string | number>();
    @Output() accept = new EventEmitter<void>();

    OnKey(key: string | number): void {
        this.keyPress.emit(key);
    }

    OnAccept(): void {
        if (this.disabled){
            return;
        }
        this.accept.emit();
    }
}
